import FollowingReviews from "./FollowingReviews";
import SimilarUserReviews from "./SimilarUserReviews";
import { PageSerializersBooksShow, UserBookSerializersUserBookReview } from "types/serializers";
import { usePage } from "@inertiajs/react";
import { BookPageProps } from "pages/clientverse/books/show.props";

export default function NetworkReviews({
  book,
  exclude,
}: {
  book: PageSerializersBooksShow;
  exclude: UserBookSerializersUserBookReview[];
}) {
  const { networkActivity } = usePage<BookPageProps>().props;

  return (
    <div className="space-y-8">
      <FollowingReviews reviews={networkActivity.followingReviews} book={book} exclude={exclude} />
      <SimilarUserReviews reviews={networkActivity.similarReviews} book={book} exclude={[...networkActivity.followingReviews, ...exclude]} />
    </div>
  );
}
